/**
 * Header behaviour:
 *  - Desktop mega menus are native <details>. On hover-capable devices they
 *    open on pointer enter (with a short intent delay) and close on leave.
 *    Only one is open at a time; Escape / overlay click / focus-out close it.
 *  - Mobile drawer sub-panels are <details>; [data-submenu-close] closes them.
 */

const header = document.querySelector('[data-header]');
const megas = header ? [...header.querySelectorAll('details[data-mega]')] : [];
const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');

const closeAll = (except) => {
  megas.forEach((details) => {
    if (details !== except) details.open = false;
  });
};

megas.forEach((details) => {
  let timer;

  details.addEventListener('toggle', () => {
    if (details.open) closeAll(details);
  });

  details.addEventListener('pointerenter', () => {
    if (!canHover.matches) return;
    clearTimeout(timer);
    timer = setTimeout(() => (details.open = true), 80);
  });

  details.addEventListener('pointerleave', () => {
    if (!canHover.matches) return;
    clearTimeout(timer);
    timer = setTimeout(() => (details.open = false), 120);
  });

  details.addEventListener('focusout', (event) => {
    if (!details.contains(event.relatedTarget)) details.open = false;
  });

  details.querySelector('[data-mega-close]')?.addEventListener('click', () => (details.open = false));

  // On hover devices the panel is already open when the pointer clicks the
  // top-level item, so a mouse click navigates instead of collapsing it.
  // Keyboard activation (event.detail === 0) keeps the native toggle.
  details.querySelector('summary')?.addEventListener('click', (event) => {
    if (!canHover.matches || event.detail === 0 || !details.open) return;
    const url = event.currentTarget.dataset.url;
    if (!url) return;
    event.preventDefault();
    window.location.href = url;
  });
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  const open = megas.find((details) => details.open);
  if (!open) return;
  open.open = false;
  open.querySelector('summary')?.focus();
});

document.addEventListener('click', (event) => {
  const back = event.target.closest('[data-submenu-close]');
  if (!back) return;
  const details = back.closest('details[data-submenu]');
  if (!details) return;
  details.open = false;
  details.querySelector('summary')?.focus();
});

document.getElementById('MenuDrawer')?.addEventListener('drawer:open', (event) => {
  event.currentTarget.querySelectorAll('details[data-submenu][open]').forEach((d) => (d.open = false));
});
